// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2faYl","title":"Images90_title__3_rQ3","images":"Images90_images__3qWeW"};